export default __webpack_public_path__ + "172d3529b26f8cedef6b5ddef7546e02.woff2";